<template>
    <div class="album-list-page">
        <div style="padding: 20px 0 0;background-color: #fff;">
            <YellowCardWarning></YellowCardWarning>
        </div>
        <div class="content-box first">
            <el-form ref="searchForm" :inline="true">
                <el-form-item>
                    <el-select v-model="params.status" placeholder="请选择审核状态">
                        <el-option label="全部专辑状态" :value="0" />
                        <el-option label="未提交" :value="10" />
                        <el-option label="待审核" :value="11" />
                        <el-option label="审核通过" :value="12" />
                        <el-option label="审核未通过" :value="13" />
                        <el-option label="修改中" :value="14" />
                        <el-option label="修改中-修改请求" :value="17" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="params.queryValue" placeholder="请输入专辑名称" prefix-icon="el-icon-search"
                        style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="search" type="primary">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="page-list-box" v-loading="listLoading">
            <div class="album-list">
                <div class="album-add" @click="onAdd">
                    <div>
                        <svg-icon icon-class="addmusic" style="font-size: 52px"></svg-icon>
                        <h5>发布歌曲</h5>
                        <p>
                            100%版税收益，
                            <br />
                            全球发行你的作品！
                        </p>
                    </div>
                </div>
                <div class="album-item" v-for="(album, index) in dataList" :key="index" @click.prevent="view(album)">
                    <div class="hd">
                        <div v-if="album.status === 10" class="status">
                            <span class="icon-unsubmitted"></span>
                            未提交
                        </div>
                        <div v-if="album.status === 12" class="status color-success">
                            <span class="icon-approve"></span>
                            审核通过
                        </div>
                        <div v-if="album.status === 11 || album.status === 16" class="status">
                            <span class="icon-checkPending"></span>
                            {{ album.status === 11 ? '待审核' : '修改待审核' }}
                        </div>
                        <div v-if="album.status === 13" class="status color-danger">
                            <span class="icon-unApprove"></span>
                            审核未通过
                        </div>
                        <div v-if="album.status === 14 && album.markStatus == 0" class="status">
                            <span class="icon-modify"></span>
                            修改中
                        </div>
                        <div v-if="album.status === 14 && album.markStatus === 1" class="status">
                            <div class="status-text">
                                <div class="icon-modify"></div>
                                修改中
                                <div class="icon-text">！修改请求</div>
                            </div>
                        </div>
                        <div v-if="album.spLinkStatus" @click.stop="goShare(album)"
                            :class="['online', album.spLinkStatus === 2 ? 'on' : 'off']">
                            {{ album.spLinkStatus === 2 ? '已上线' : '即将上线' }}
                            <span v-if="album.spLinkStatus === 2" class="icon-more"></span>
                        </div>
                    </div>
                    <div class="bd">
                        <div class="cover">
                            <el-image :src="$utils.coverImg(album.cover, 200, 200)" fit="cover">
                                <div slot="error" class="image-slot">
                                    <i class="el-icon-picture-outline"></i>
                                </div>
                            </el-image>
                        </div>
                        <h5>{{ album.albumName }}</h5>
                        <p>{{ album.showArtist }}</p>
                        <p>{{ album.genreName }}</p>
                        <p v-if="album.status === 12 && album.authStartTime">
                            授权时间：{{ $utils.formatDate(album.authStartTime) }} 至 {{ $utils.formatDate(album.authEndTime)
                            }}
                        </p>
                        <el-button v-if="album.status == 10" @click.stop="del(album.id)" type="icon"
                            icon="el-icon-delete"></el-button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="prev, pager, next" :total="data.totalCount || 0"></el-pagination>
        </div>
        <AddAlbum :visible.sync="addAlbumVisible" :quantity="dataList.length"></AddAlbum>
    </div>
</template>

<script>
import AddAlbum from '../components/AddAlbum';
import YellowCardWarning from '@/components/YellowCardWarning';
const defaultParams = {
    pageNo: 1,
    queryKeyType: 1,
    status: 0,
    queryValue: '',
    contractNo: null,
};
export default {
    components: {
        AddAlbum,
        YellowCardWarning
    },
    data() {
        return {
            albumTypeName: 1,
            data: null,
            dataList: [],
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || 11),
                queryKeyType: parseInt(this.$route.query.queryKeyType || 1),
                status: (() => {
                    const status = parseInt(this.$route.query.status || 0);
                    const markStatus = parseInt(this.$route.query.markStatus || 0);
                    // 如果是修改请求状态，返回17
                    if (status === 14 && markStatus === 1) {
                        return 17;
                    }
                    return status;
                })(),
                queryValue: this.$route.query.queryValue || '',
                contractNo: this.$route.query.contractNo || '',
                markStatus: this.$route.query.markStatus || null,
            },
            listLoading: true,
            visible: false,
            addAlbumVisible: false,
        };
    },
    computed: {
        verify() {
            if (this.$store.state.verify) return this.$store.state.verify;
            return {};
        },
        status() {
            return {
                10: { name: '未提交', type: 'info' },
                11: { name: '待审核', type: 'wait' },
                12: { name: '审核通过', type: 'success' },
                13: { name: '审核未通过', type: 'danger' },
                14: { name: '修改中', type: 'info' },
                15: { name: '删除', type: 'info' },
                16: { name: '修改待审核', type: 'warning' },
                17: { name: '修改中-修改请求', type: 'info' },
            };
        },
        ifLimitAlbumForShowStart() {
            return this.$store.state.userData && this.$store.state.userData.ifLimitAlbumForShowStart;
        },
    },
    mounted() {
        this.$store.dispatch('getUserInfo');
        this.getDataList();
    },
    methods: {
        onAdd() {
            const { isAlbumCreate } = this.$store.getters;
            if (isAlbumCreate)
                return this.$confirm(isAlbumCreate, '暂停专辑创建', {
                    type: 'error',
                    center: true,
                    closeOnClickModal: false,
                    dangerouslyUseHTMLString: true,
                });
            this.addAlbumVisible = true;
        },
        //获取列表数据
        getDataList() {
            this.listLoading = true;
            const requestParams = { ...this.params };
            if (requestParams.status === 17) {
                requestParams.status = 14;
                requestParams.markStatus = 1;
            } else if(requestParams.status === 14) {
                requestParams.status = 14;
                requestParams.markStatus = 0;
            } else{
                requestParams.markStatus = null;
            }
            this.$request({
                url: '/album/view/listV2',
                params: requestParams,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || '请求失败');
                    }
                })
                .catch(() => {
                    this.$message.error('请求错误');
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //删除
        del(id) {
            this.$confirm('删除后专辑信息将永久丢失不可恢复，删除后不会退还专辑使用费用!', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false,
                dangerouslyUseHTMLString: true,
            })
                .then(() => {
                    this.listLoading = true;
                    this.$request({
                        url: '/newAlbum/up/delete',
                        method: 'POST',
                        data: { albumId: id },
                        formData: false,
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                if (this.dataList.length == 1) {
                                    this.params.pageNo = 1;
                                }
                                this.getDataList();
                            } else {
                                this.$message.error(msg || '请求失败');
                            }
                        })
                        .catch(() => {
                            this.$message.error('请求错误');
                        });
                })
                .catch(() => { });
        },
        //查看
        view(data) {
            this.$router.push({
                path: `/manage/album/detail/${data.id}`,
                query: {
                    redirect: this.$utils.objArgs(this.$router.currentRoute.path, this.params),
                    count: this.dataList.length,
                    markStatus:data.markStatus,
                    markMessage: data.markMessage
                },
            });
        },
        viewTrack(data) {
            let path = `/manage/album/songList/${data.id}`;
            this.$router.push({
                path: path,
                query: {
                    redirect: this.$utils.objArgs(this.$router.currentRoute.path, this.params),
                    count: this.dataList.length,
                },
            });
        },
        goShare(album) {
            if (album.spLinkStatus == 2) this.$router.push(`/manage/album/share/${album.id}`);
        },
        onPass() {
            this.$router.push(this.albumTypeName == 1 ? `/manage/album/singleTrackInfo/add?quantity=${this.dataList.length}` : '/manage/album/add');
        },
    },
};
</script>

<style lang="scss" scoped>
.album-list-page {
    .first {
        border-radius: 0 0 10px 10px;
    }
}

.not-certified {
    padding: 70px 0;
    text-align: center;

    .title {
        font-size: 24px;
        font-weight: 500;
        color: #000000;
        line-height: 33px;
    }

    p {
        color: #909399;
        margin: 12px 0 0px;
    }

    ul {
        margin-top: 20px;

        li {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            margin-bottom: 4px;
            color: #909399;

            &.active {
                color: #5a11f1;
            }
        }
    }

    .el-button {
        border: 1px solid #000000;
        border-radius: 20px;
        padding: 12px 37px;
        color: #000;
        background: transparent;
        margin-top: 30px;
    }
}

.album-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;

    .album-item {
        background: $--color-white;
        padding: 30px;
        border-radius: 10px;
        cursor: pointer;
        width: calc(33.33% - 14px);
        margin-right: 20px;
        margin-bottom: 20px;
        position: relative;

        &:hover {
            box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
        }

        .click {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: 3;
        }

        .hd {
            color: $-text-600;
            position: relative;
            z-index: 1;

            .status {
                font-size: 12px;
                line-height: 12px;
                display: flex;
                align-items: center;

                span {
                    width: 12px;
                    height: 12px;
                    display: inline-block;
                    background-repeat: no-repeat;
                    background-size: cover;
                    margin-right: 8px;
                }

                .icon-unsubmitted {
                    background-image: url('~@/assets/img/album/list_wtj.svg');
                }

                .icon-approve {
                    background-image: url('~@/assets/img/album/list_pass.svg');
                }

                .icon-checkPending {
                    background-image: url('~@/assets/img/album/list_wait.svg');
                }

                .icon-unApprove {
                    background-image: url('~@/assets/img/album/list_fail.svg');
                }

                .icon-modify {
                    background-image: url('~@/assets/img/album/list_edit.svg');
                }
                .status-text {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    .icon-text {
                        margin-left: 10px;
                        color: red;
                    }
                }
            }

            .online {
                width: 90px;
                height: 40px;
                border-radius: 0px 10px 0px 10px;
                position: absolute;
                top: -30px;
                right: -30px;
                text-align: center;
                font-size: 12px;
                line-height: 40px;

                &.on {
                    background-color: rgba($color: $--color-base, $alpha: 0.1);
                    color: $--color-base;
                }

                &.off {
                    background-color: $--color-grey;
                    color: $-text-500;
                }
            }

            .icon-more {
                width: 11px;
                height: 8px;
                background-image: url('~@/assets/img/album/list_more.svg');
                display: inline-block;
            }
        }

        .bd {
            position: relative;

            .cover {
                width: 140px;
                height: 140px;
                margin-top: 20px;
                position: relative;
                z-index: 10;
                filter: blur(0px);

                .el-image {
                    border-radius: 6px;
                    overflow: hidden;
                    background: url('~@/assets/img/upload/bg.png') no-repeat center;
                    background-size: cover;
                    width: 140px;
                    height: 140px;
                }

                &::after {
                    content: '';
                    background: url('~@/assets/img/album/pic_cd.png') no-repeat center;
                    background-size: cover;
                    width: 30px;
                    height: 108px;
                    position: absolute;
                    top: 16px;
                    right: -30px;
                }
            }

            h5 {
                font-size: 18px;
                line-height: 18px;
                margin-top: 30px;
                margin-bottom: 18px;
                font-weight: 600;
            }

            p {
                font-size: 12px;
                color: $-text-500;
                line-height: 12px;
                margin-bottom: 10px;
            }

            .el-button--icon {
                font-size: 16px;
                position: absolute;
                bottom: 0px;
                right: 0px;
                z-index: 9;
                background-color: $--input-background-color;
                width: 50px;
                height: 50px;
                border-radius: 50%;

                &:hover {
                    background-color: rgba($color: $--color-primary, $alpha: 0.1);
                    color: $--color-danger;
                }
            }
        }

        &:nth-of-type(3n) {
            margin-right: 0;
        }
    }

    .album-add {
        background: $--color-white;
        border-radius: 10px;
        text-align: center;
        cursor: pointer;
        width: calc(33.33% - 13px);
        margin-right: 20px;
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 260px;

        &:hover {
            box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
        }

        .el-icon-plus {
            font-size: 20px;
        }

        h5 {
            font-size: 18px;
            color: $-text-950;
            line-height: 18px;
            margin-top: 20px;
        }

        p {
            color: $-text-500;
            font-size: 12px;
            margin-top: 12px;
        }
    }
}

.album-list-page {
    .content-box {
        padding-bottom: 20px;
    }
}
</style>
